import { Route, Routes } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { CardPlaceholder } from './pages/CardPlaceholder';
import { IncomeSales } from './pages/IncomeSales';
import { Expenses } from './pages/Expenses';
import { CashBank } from './pages/CashBank';
import { Landing } from './pages/Landing';
import { Onboarding } from './pages/Onboarding';
import { SignInPage } from './pages/SignInPage';
import { SignUpPage } from './pages/SignUpPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { RequireBusiness } from './components/RequireBusiness';

export function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Landing />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />

      {/* Signed-in, but no business required yet — the create-first-business wizard */}
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            <Onboarding />
          </ProtectedRoute>
        }
      />
      <Route
        path="/businesses/new"
        element={
          <ProtectedRoute>
            <Onboarding mode="add" />
          </ProtectedRoute>
        }
      />

      {/* Protected routes — require sign-in AND at least one business */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <RequireBusiness>
              <Dashboard />
            </RequireBusiness>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cash-bank"
        element={
          <ProtectedRoute>
            <RequireBusiness>
              <CashBank />
            </RequireBusiness>
          </ProtectedRoute>
        }
      />
      <Route
        path="/income"
        element={
          <ProtectedRoute>
            <RequireBusiness>
              <IncomeSales />
            </RequireBusiness>
          </ProtectedRoute>
        }
      />
      <Route
        path="/expense"
        element={
          <ProtectedRoute>
            <RequireBusiness>
              <Expenses />
            </RequireBusiness>
          </ProtectedRoute>
        }
      />
      <Route
        path="/general"
        element={
          <ProtectedRoute>
            <RequireBusiness>
              <CardPlaceholder title="General / Adjustments" />
            </RequireBusiness>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tax"
        element={
          <ProtectedRoute>
            <RequireBusiness>
              <CardPlaceholder title="Tax / Compliance" />
            </RequireBusiness>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <ProtectedRoute>
            <RequireBusiness>
              <CardPlaceholder title="Reports" />
            </RequireBusiness>
          </ProtectedRoute>
        }
      />

      {/* Catch-all */}
      <Route path="*" element={<CardPlaceholder title="Not Found" />} />
    </Routes>
  );
}
